/**
 * Today's Read
 * The home page's Read tab: fetches today's piece and shows it.
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { capture } from '../../utils/analytics';
import ReadPieceView from './ReadPieceView';

const TodaysRead = () => {
  const [piece, setPiece] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    axios.get('/api/read/today')
      .then((res) => {
        setPiece(res.data);
        capture('read_viewed', { kind: res.data.kind });
      })
      .catch(() => setFailed(true));
  }, []);

  if (!piece) {
    return (
      <div className="read-placeholder">
        {failed ? 'Nothing to read today. Check back tomorrow.' : 'Loading today’s read...'}
      </div>
    );
  }
  return <ReadPieceView piece={piece} />;
};

export default TodaysRead;
